import {
  ENABLE_MATS_REWARDS_FOR_BORROW,
  ENABLE_MATS_REWARDS_FOR_SIGNUP,
} from "#/shared/constants"

import createDappAsyncThunk from "../asyncThunk"
import { setMatsForBorrow } from "../slices/borrow"

export const fetchMatsForBorrow = createDappAsyncThunk(
  "mats/fetchMatsForBorrow",
  async (_, { dispatch, extra: { sdk } }) => {
    if (!ENABLE_MATS_REWARDS_FOR_BORROW) return

    const matsForBorrow = await sdk.mezo.api.mats.getMatsForBorrow()

    dispatch(setMatsForBorrow(matsForBorrow))
  },
)

export const claimMatsForBorrow = createDappAsyncThunk(
  "mats/claimMatsForBorrow",
  async (_, { dispatch, extra: { sdk } }) => {
    if (!ENABLE_MATS_REWARDS_FOR_BORROW) return false

    const claimResult = await sdk.mezo.api.mats.claimMatsForBorrow()

    if (claimResult) {
      await dispatch(fetchMatsForBorrow())
    }

    return claimResult
  },
)

export const grantMatsForSignUp = createDappAsyncThunk(
  "mats/grantMatsForSignUp",
  async (_, { extra: { sdk } }) => {
    if (!ENABLE_MATS_REWARDS_FOR_SIGNUP) return false

    const grantMatsResult = await sdk.mezo.api.mats.grantMatsForSignUp()

    return !!grantMatsResult
  },
)
